var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.78,460.33c28.83,18.62,83-4,103.61-25.24C363.4,366,481.93,249.32,459,127.7c-9.77-51.69-61.3-67.53-82-70.81C327.16,49,276.24,55.42,226.8,65.15c-51.63,10.16-106,25.29-145.92,61.41C65.76,140.25,52.27,156.36,45,175.63c-7.34,19.57-9,41.16-5.87,61.77,5.12,33.23,21.83,63.73,42.34,90.37s44.92,50,68,74.41C164.63,418.11,168.5,444.65,192.78,460.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,460.33c28.83,18.62,83-4,103.61-25.24C363.4,366,481.93,249.32,459,127.7c-9.77-51.69-61.3-67.53-82-70.81C327.16,49,276.24,55.42,226.8,65.15c-51.63,10.16-106,25.29-145.92,61.41C65.76,140.25,52.27,156.36,45,175.63c-7.34,19.57-9,41.16-5.87,61.77,5.12,33.23,21.83,63.73,42.34,90.37s44.92,50,68,74.41C164.63,418.11,168.5,444.65,192.78,460.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89,187.42l-3.92-.34a15.29,15.29,0,0,0-1.42-3.44l3.72-4.42-5.44-5.44m5.44,29.85-3.72-4.42a15.37,15.37,0,0,0,1.42-3.45l5.76-.49v-7.69M77.5,205.35l4.41,3.71,3.7-3.7m-31.25-9.6a15.85,15.85,0,0,0,1.42,3.45l-3.71,4.42,5.43,5.43,4.42-3.71a15.85,15.85,0,0,0,3.45,1.42l.49,5.76h7.69l.5-5.76M54.32,177l-2.25,2.26,3.71,4.42a15.77,15.77,0,0,0-1.42,3.44l-5.76.5v7.69l3.47.34M77.5,177.5a16.06,16.06,0,0,0-3.45-1.42l-.5-5.76H65.86l-.49,5.76a15.85,15.85,0,0,0-3.45,1.42l-4.42-3.72-1.73,1.73m7.8,9.42a8.94,8.94,0,0,1,14.37,3M66.62,199.81a8.94,8.94,0,0,1-5.84-8.39m17.86,0a8.93,8.93,0,0,1-8.93,8.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,87.2l-6.22-.54a24.82,24.82,0,0,0-2.26-5.47l5.9-7-8.63-8.63m8.63,47.36-5.9-7a24.82,24.82,0,0,0,2.26-5.47l9.13-.79V87.45m-21.12,28.19,7,5.9,5.87-5.87M406.28,127h5.19l.79-9.13M381,70.6l-3.58,3.58,5.9,7A25.31,25.31,0,0,0,381,86.66l-9.13.79m45.85-16a25.6,25.6,0,0,0-5.48-2.26l-.79-9.13H399.28l-.79,9.13A25.31,25.31,0,0,0,393,71.45l-7-5.9-2.74,2.74m12.37,15A14.16,14.16,0,0,1,418.43,88m1.12,5.51a14.18,14.18,0,0,1-14.17,14.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.21,373a5.08,5.08,0,0,0-3-2.51l-63-19.91a5.06,5.06,0,0,0-4,.43l-3-.93a1.52,1.52,0,0,0-2.94-.74l-.35,1.08-52.38-16.56a.53.53,0,0,0-.25,0l-3.36.68a.49.49,0,0,0-.38.34.51.51,0,0,0,.11.49l2.36,2.49a.5.5,0,0,0,.22.13l52.38,16.56-.34,1.08a1.51,1.51,0,0,0,.1,1.16,1.53,1.53,0,0,0,.89.75,1.51,1.51,0,0,0,1.16-.1,1.46,1.46,0,0,0,.68-.71l3,.93a5.07,5.07,0,0,0,3.06,2.68l63,19.91a5.11,5.11,0,0,0,6.42-3.34A5.09,5.09,0,0,0,384.21,373Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.09,361.58l-3.17-1a.5.5,0,0,0-.33-.57l-4.26-1.32a.51.51,0,0,0-.63.33l-1.15,3.73a.5.5,0,0,0,.33.62l4.26,1.32.15,0a.5.5,0,0,0,.45-.3l3.17,1a1.44,1.44,0,0,1,.94,1.79l-9,28.95a.52.52,0,0,0,.15.53l-.9,2.92a.51.51,0,0,0,0,.38.53.53,0,0,0,.29.24l2.3.71a.32.32,0,0,0,.14,0,.5.5,0,0,0,.48-.35l.91-2.93a.33.33,0,0,0,.17,0,.46.46,0,0,0,.24-.29l9-29a5.45,5.45,0,0,0-3.58-6.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.48,383.16a.45.45,0,0,0,.1-.31.46.46,0,0,0-.16-.35l-3.31-3a.49.49,0,0,0-.36-.13.53.53,0,0,0-.35.17l-2.61,2.89a.5.5,0,0,0,0,.71l3.3,3a.55.55,0,0,0,.34.13h0a.46.46,0,0,0,.31-.13l2.46,2.22a1.45,1.45,0,0,1,.47,1,1.4,1.4,0,0,1-.37,1l-20.31,22.49a.49.49,0,0,0-.08.54l-2,2.27a.5.5,0,0,0,0,.71l1.78,1.6a.5.5,0,0,0,.33.13.51.51,0,0,0,.38-.16l2-2.27a.45.45,0,0,0,.16,0h0a.51.51,0,0,0,.34-.17l20.31-22.49a5.44,5.44,0,0,0-.39-7.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.45,394.2l-8.89,2.38-2.65-2.66,1-3.62,8.89-2.37a.51.51,0,0,0,.34-.33.48.48,0,0,0-.07-.46,10.23,10.23,0,0,0-17.63,2.46l-85,22.73a9.59,9.59,0,0,0-15.07,6.56.5.5,0,0,0,.62.55l8.28-2.22,2.45,2.45-.9,3.34-8.28,2.22a.5.5,0,0,0-.26.79,9.57,9.57,0,0,0,7.59,3.74,9.74,9.74,0,0,0,2.5-.32,9.59,9.59,0,0,0,6.24-5.28l84.94-22.73a11.46,11.46,0,0,0,1.22.84,10.26,10.26,0,0,0,15.29-7.52.51.51,0,0,0-.16-.44A.52.52,0,0,0,315.45,394.2Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "323.84 353.94 322.84 357.11 254.41 335.47 252.05 332.99 255.41 332.31 323.84 353.94",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.26,349.53l-3.64-1.15.09-.3a1,1,0,0,0-1.95-.62l-2,6.28a1,1,0,1,0,2,.62l.09-.3,3.64,1.15a4.61,4.61,0,0,0,2.85,2.62l63,19.9a4.61,4.61,0,0,0,2.78-8.8l-63-19.91A4.61,4.61,0,0,0,314.26,349.53Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.26,
    y1: 349.53,
    x2: 312.98,
    y2: 353.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.82,
    y1: 354.06,
    x2: 309.98,
    y2: 350.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.39,
    y: 395.02,
    width: 3.92,
    height: 2.4,
    transform: "translate(-259.22 440.91) rotate(-72.81)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.24,395.18l-2.87-.89,9-29a1.93,1.93,0,0,0-1.28-2.41l-6.44-2,.89-2.86,6.44,2a4.93,4.93,0,0,1,3.25,6.17Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.78,
    y: 357.48,
    width: 3.9,
    height: 4.46,
    transform: "translate(-223.37 416.52) rotate(-72.81)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.54,
    y: 412.15,
    width: 3.92,
    height: 2.4,
    transform: "translate(-264.42 231.72) rotate(-47.92)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.65,413.21l-2.23-2,20.31-22.5a1.92,1.92,0,0,0-.14-2.72l-5-4.52,2-2.23,5,4.52a4.93,4.93,0,0,1,.36,7Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 378.6,
    width: 3.9,
    height: 4.46,
    transform: "translate(-234.79 233.32) rotate(-47.92)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.86,
    y: 399.27,
    width: 95.21,
    height: 11.24,
    transform: "translate(-96 79.82) rotate(-14.98)",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,409.37a9.1,9.1,0,0,0-6.67,7.58l8.56-2.29,2.85,2.86-1,3.9-8.56,2.29a9.1,9.1,0,1,0,4.86-14.34Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.43,400.81a9.76,9.76,0,0,0,7.15-8.13l-9.17,2.45-3.05-3.06,1.12-4.17,9.16-2.46a9.75,9.75,0,1,0-5.21,15.37Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.83,398.79l-60.3,16.14a2.21,2.21,0,0,1-2.72-1.57h0a2.22,2.22,0,0,1,1.57-2.71l60.31-16.14a2.22,2.22,0,0,1,2.71,1.57h0A2.22,2.22,0,0,1,286.83,398.79Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.53,92.07h13.68a1,1,0,0,1,1,1v5.77a0,0,0,0,1,0,0H339.55a0,0,0,0,1,0,0V93.06A1,1,0,0,1,340.53,92.07Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.16,92.07h13.68a1,1,0,0,1,1,1v5.77a0,0,0,0,1,0,0H358.17a0,0,0,0,1,0,0V93.06A1,1,0,0,1,359.16,92.07Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,92.07H155a1,1,0,0,1,1,1v5.77a0,0,0,0,1,0,0H124.16a0,0,0,0,1,0,0V93.06A1,1,0,0,1,125.15,92.07Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.3,
    y: 51.35,
    width: 221.73,
    height: 306.27,
    rx: 20.77,
    transform: "translate(453.65 -44.69) rotate(90)",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.37,
    y: 95.94,
    width: 301.61,
    height: 217.08,
    rx: 17.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,196.38a1,1,0,1,1-1-1A1,1,0,0,1,102.83,196.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77,205.7a2,2,0,1,1-2-2A2,2,0,0,1,103.77,205.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24,212.17a1.43,1.43,0,1,1-1.43-1.42A1.43,1.43,0,0,1,103.24,212.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 60.66,
    width: 203.1,
    height: 287.64,
    rx: 8.77,
    transform: "translate(453.65 -44.69) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 60.66,
    width: 203.1,
    height: 287.64,
    rx: 8.77,
    transform: "translate(453.65 -44.69) rotate(90)",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,146.18H128.26a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h55.26a1,1,0,0,1,1,1h0A1,1,0,0,1,183.52,146.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,158.19H128.26a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h39.07a1,1,0,0,1,1,1h0A1,1,0,0,1,167.33,158.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.62,170.2H128.26a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h63.36a1,1,0,0,1,1,1h0A1,1,0,0,1,191.62,170.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,182.21H128.26a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h55.26a1,1,0,0,1,1,1h0A1,1,0,0,1,183.52,182.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,194.22H128.26a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h39.07a1,1,0,0,1,1,1h0A1,1,0,0,1,167.33,194.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 142.61,
    width: 14.38,
    height: 5.1,
    rx: 1.76,
    transform: "translate(411.42 290.33) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 142.61,
    width: 5.73,
    height: 5.1,
    rx: 1.76,
    transform: "translate(402.76 290.33) rotate(180)",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 154.63,
    width: 14.38,
    height: 5.1,
    rx: 1.76,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.18,
    y: 154.63,
    width: 5.73,
    height: 5.1,
    rx: 1.76,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 166.64,
    width: 14.38,
    height: 5.1,
    rx: 1.76,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.18,
    y: 166.64,
    width: 5.73,
    height: 5.1,
    rx: 1.76,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 178.65,
    width: 14.38,
    height: 5.1,
    rx: 1.76,
    transform: "translate(411.42 362.39) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 178.65,
    width: 5.73,
    height: 5.1,
    rx: 1.76,
    transform: "translate(402.76 362.39) rotate(180)",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.52,
    y: 190.66,
    width: 14.38,
    height: 5.1,
    rx: 1.76,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.18,
    y: 190.66,
    width: 5.73,
    height: 5.1,
    rx: 1.76,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52,158.19h-50.4a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h50.4a1,1,0,0,1,1,1h0A1,1,0,0,1,289.52,158.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.43,146.18H239.12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h42.31a1,1,0,0,1,1,1h0A1,1,0,0,1,281.43,146.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52,194.22h-50.4a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h50.4a1,1,0,0,1,1,1h0A1,1,0,0,1,289.52,194.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.33,182.21H239.12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h34.21a1,1,0,0,1,1,1h0A1,1,0,0,1,273.33,182.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23,170.2H239.12a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h26.11a1,1,0,0,1,1,1h0A1,1,0,0,1,265.23,170.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.02,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.48,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.07,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.36,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.65,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.24,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 143.38,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.02,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.48,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.07,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.36,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.65,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.24,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 155.39,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.02,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.48,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.07,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.36,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.65,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.24,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 191.42,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.02,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.48,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.07,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.36,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.65,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.24,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 179.41,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.02,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.6,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.48,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.77,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.07,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.36,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.65,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.24,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.53,
    y: 167.4,
    width: 3.56,
    height: 3.56,
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44,148.91H127.76a.51.51,0,0,1-.51-.51h0a.5.5,0,0,1,.51-.5h48.68a.5.5,0,0,1,.51.5h0A.51.51,0,0,1,176.44,148.91Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.68,160.92H127.76a.51.51,0,0,1-.51-.51h0a.5.5,0,0,1,.51-.5h51.92a.5.5,0,0,1,.51.5h0A.51.51,0,0,1,179.68,160.92Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,172.93H127.76a.51.51,0,0,1-.51-.51h0a.5.5,0,0,1,.51-.5h19.53a.5.5,0,0,1,.51.5h0A.51.51,0,0,1,147.29,172.93Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,184.94H127.76a.51.51,0,0,1-.51-.51h0a.5.5,0,0,1,.51-.5h35.72a.5.5,0,0,1,.51.5h0A.51.51,0,0,1,163.48,184.94Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,197H127.76a.51.51,0,0,1-.51-.51h0a.5.5,0,0,1,.51-.5h35.72a.5.5,0,0,1,.51.5h0A.51.51,0,0,1,163.48,197Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.58,148.91h-39a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.5h39a.5.5,0,0,1,.51.5h0A.51.51,0,0,1,277.58,148.91Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,160.92H238.61a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.5h22.78a.5.5,0,0,1,.5.5h0A.5.5,0,0,1,261.39,160.92Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,172.93H238.61a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.5h22.78a.5.5,0,0,1,.5.5h0A.5.5,0,0,1,261.39,172.93Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,184.94H238.61a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.5h47.07a.5.5,0,0,1,.5.5h0A.5.5,0,0,1,285.68,184.94Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,197H238.61a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.5h47.07a.5.5,0,0,1,.5.5h0A.5.5,0,0,1,285.68,197Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.83,
    cy: 245.71,
    r: 27.68,
    transform: "translate(-101.82 177.66) rotate(-35.96)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91,230h0a1.16,1.16,0,0,1-.74-1.46l1.65-5.13a1.16,1.16,0,0,1,1.46-.74h0a1.14,1.14,0,0,1,.74,1.45l-1.65,5.13A1.17,1.17,0,0,1,227.91,230Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 222.83,
    cy: 245.71,
    r: 32.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      strokeDasharray: "0.9752489924430847,14.628700256347656"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.29,286H133.18a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h26.11a1,1,0,0,1,1,1h0A1,1,0,0,1,159.29,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.63,288.74H134.85a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.51h22.78a.5.5,0,0,1,.5.51h0A.5.5,0,0,1,157.63,288.74Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.89,286H209.77a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h26.12a1,1,0,0,1,1,1h0A1,1,0,0,1,235.89,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.22,288.74H211.44a.5.5,0,0,1-.5-.51h0a.5.5,0,0,1,.5-.51h22.78a.5.5,0,0,1,.5.51h0A.5.5,0,0,1,234.22,288.74Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.8,
    y: 210.31,
    width: 106.6,
    height: 79.38,
    rx: 3.24,
    style: {
      fill: "#407BFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.32,
    y: 222.73,
    width: 45.21,
    height: 6.49,
    rx: 1.86,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.88 224.73 372.43 227.22 373.98 224.73 370.88 224.73",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.23,227H333.84a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h16.39a1,1,0,0,1,1,1h0A1,1,0,0,1,350.23,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.32,
    y: 270.77,
    width: 45.21,
    height: 6.49,
    rx: 1.86,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.88 272.77 372.43 275.26 373.98 272.77 370.88 272.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.23,275H333.84a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h16.39a1,1,0,0,1,1,1h0A1,1,0,0,1,350.23,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.32,
    y: 234.74,
    width: 45.21,
    height: 6.49,
    rx: 1.86,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.88 236.74 372.43 239.23 373.98 236.74 370.88 236.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,239H333.84a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h21.25a1,1,0,0,1,1,1h0A1,1,0,0,1,355.09,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.32,
    y: 246.75,
    width: 45.21,
    height: 6.49,
    rx: 1.86,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.88 248.75 372.43 251.25 373.98 248.75 370.88 248.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.23,251H333.84a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h16.39a1,1,0,0,1,1,1h0A1,1,0,0,1,350.23,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.32,
    y: 258.76,
    width: 45.21,
    height: 6.49,
    rx: 1.86,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.88 260.76 372.43 263.25 373.98 260.76 370.88 260.76",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,263H333.84a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h21.25a1,1,0,0,1,1,1h0A1,1,0,0,1,355.09,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.27,227H287.68a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h32.59a1,1,0,0,1,1,1h0A1,1,0,0,1,320.27,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,239H287.68a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h22.87a1,1,0,0,1,1,1h0A1,1,0,0,1,310.55,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,251H287.68a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h26.11a1,1,0,0,1,1,1h0A1,1,0,0,1,313.79,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.69,263h-18a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h18a1,1,0,0,1,1,1h0A1,1,0,0,1,305.69,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,275H287.68a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h22.87a1,1,0,0,1,1,1h0A1,1,0,0,1,310.55,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.24,
    cy: 245.71,
    r: 27.68,
    transform: "translate(-117.46 356.25) rotate(-81.98)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,245.07h0a1.15,1.15,0,0,1,1.11-1.2l5.38-.21a1.15,1.15,0,0,1,1.2,1.11h0a1.15,1.15,0,0,1-1.11,1.2l-5.38.21A1.15,1.15,0,0,1,162.78,245.07Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.24,
    cy: 245.71,
    r: 32.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      strokeDasharray: "0.9752489924430847,14.628700256347656"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "252.37 300.71 249.17 299.47 245.98 300.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "252.37 303.14 249.17 301.9 245.98 303.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.95,
    y: 112.03,
    width: 270.45,
    height: 17.5,
    rx: 3,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.84,121.77v-2l-1.49-.13a4.08,4.08,0,0,0-.37-.89l1-1.14-1.4-1.4-1.14,1a3.89,3.89,0,0,0-.89-.37l-.13-1.48h-2l-.12,1.48a3.71,3.71,0,0,0-.89.37l-1.14-1-1.4,1.4,1,1.14a4.61,4.61,0,0,0-.36.89l-1.49.13v2l1.49.13a4.61,4.61,0,0,0,.36.89l-1,1.13,1.4,1.41,1.14-1a3.69,3.69,0,0,0,.89.36l.12,1.49h2l.13-1.49a3.86,3.86,0,0,0,.89-.36l1.14,1,1.4-1.41-1-1.13a4.08,4.08,0,0,0,.37-.89Zm-5.45,1.31a2.31,2.31,0,1,1,2.31-2.3A2.3,2.3,0,0,1,229.39,123.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,116c1.42,0,2.14.85,2.14,2.33v.3h-1.37v-.39c0-.66-.27-.91-.73-.91s-.73.25-.73.91.29,1.18,1.24,2c1.22,1.07,1.61,1.84,1.61,2.9a2,2,0,0,1-2.18,2.33c-1.43,0-2.17-.85-2.17-2.33v-.57h1.38v.66c0,.67.29.9.75.9s.76-.23.76-.9-.29-1.18-1.25-2c-1.22-1.08-1.6-1.84-1.6-2.91C237.47,116.88,238.2,116,239.62,116Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.07,120.05h2v1.32h-2v2.72h2.52v1.33h-4v-9.28h4v1.32h-2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.06,116.14h4.51v1.32h-1.52v8h-1.46v-8h-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,116.14h4.51v1.32h-1.53v8h-1.45v-8h-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,116.14h1.46v9.28h-1.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.77,118.7h0v6.72h-1.31v-9.28h1.83l1.47,5.55h0v-5.55h1.3v9.28h-1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.29,120.25h2v2.94a2,2,0,0,1-2.18,2.33c-1.43,0-2.17-.85-2.17-2.33v-4.83c0-1.48.74-2.33,2.17-2.33a2,2,0,0,1,2.18,2.33v.91H268v-1c0-.66-.29-.91-.76-.91s-.75.25-.75.91v5c0,.67.29.9.75.9s.76-.23.76-.9v-1.71h-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23,116c1.42,0,2.15.85,2.15,2.33v.3H273v-.39c0-.66-.27-.91-.73-.91s-.73.25-.73.91.29,1.18,1.25,2a3.58,3.58,0,0,1,1.6,2.9c0,1.48-.74,2.33-2.17,2.33a2,2,0,0,1-2.18-2.33v-.57h1.38v.66c0,.67.29.9.76.9s.75-.23.75-.9-.29-1.18-1.24-2c-1.22-1.08-1.61-1.84-1.61-2.91C270.08,116.88,270.81,116,272.23,116Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.44,102.93,105.35,228V111.7a8.77,8.77,0,0,1,8.77-8.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.79 102.93 105.35 269.37 105.35 262.68 265.1 102.93 271.79 102.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.6 102.93 136.5 306.03 134.41 306.03 337.5 102.93 339.6 102.93",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.51,147.39c-7-.45-8.86,11.57-8.86,23.58s4,19.77,5.29,24,1.23,18.28-.84,23.92-10.84,23.39-16.55,33.75,2.3,41.85,6.81,49.86,28.42,15.55,33.68,25,2.87,12.17,7.69,19.2,27.64,31.66,40.22,75.79l10.91-149.77-41.34-44.48Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.38,429.07l-.18.22.84-.35C426.79,429,426.56,429.05,426.38,429.07Zm60.47-74.67c-.77-1.27-1.5-2.5-2.2-3.69h0c-14.28-24.34-16.82-34.78-18.52-41.8a39,39,0,0,0-3.08-9.23l-.83-1.6a55.3,55.3,0,0,1-5.39-13.26c-.86-3.69.35-12.68,1.52-21.37.84-6.27,1.64-12.18,1.56-15.54l0-1.19c-.2-8.8-.62-27.1-2.45-32.23-1.76-4.93-3.53-5.71-6.75-7.11l-1-.46c-1.21-.54-3.25-1.67-5.61-3-5.3-2.93-11.91-6.6-15.3-7.16a29.94,29.94,0,0,0-9.56.17c-4.12-3.34-11.13-7.7-13.26-7.84s-7.46,1.37-8.35,1.62a24.5,24.5,0,0,0-3.82-2.6c-3.05-1.38-8.19-1.2-9.12-1.15-3.51-5.74-7-11.48-8.45-14-2.67-4.5-10-20.87-12.16-25.76-.38-.86-.6-1.37-.62-1.4a.29.29,0,0,0-.13-.14c-.07,0-6.47-2.28-9.15,3.66s.54,19.64,3.95,24.62c1.65,2.41,6.05,12.16,10.51,22.24h0c-.32.29-1.23,1.08-2.48,2.13-3.59,3-10,8.08-13.54,9.23-3.91,1.26-3.56,21.14-3.29,37.12.1,5.88.19,11,0,14-.15,2.85,2.24,6.29,5.9,10l.05,0a176.69,176.69,0,0,0,14.38,12.38c9.19,7.37,18.69,15,19.67,20.35a27.8,27.8,0,0,0,6.94,14.36c4.91,5.06,22.5,81.94,28,106.11,1,4.49,1.63,7.15,1.66,7.23l.49-.1c3.51-4.35,60.42-74.33,60.38-74.34A.25.25,0,0,0,486.85,354.4ZM367.67,218.47c.7-.68,5.42-5.39,6.32-10.07,3.2,7.22,5.18,11.56,5.67,12s.4,2.74.32,4.94a39.77,39.77,0,0,0,0,5.79c-.84.7-6.22,5.33-7.39,9.15l-4.31-5.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,225.56c1.48-6.29-6-12.57-14.72-29.37-.32.29-1.23,1.08-2.48,2.13,1.32,3.57,2.28,7.7.46,9.18-3.46,2.82-4.81,2.91-4.65,6s4.17,24.92,2.48,30,10,6.48,11.82,7.49-.08-7.91,4.36-11.66S381.64,232.57,383.29,225.56Zm-10.66,14.75-4.31-5.37-.65-16.47c.7-.68,5.42-5.39,6.32-10.07,3.2,7.22,5.18,11.56,5.67,12s.4,2.74.32,4.94a39.77,39.77,0,0,0,0,5.79C379.18,231.86,373.8,236.49,372.63,240.31Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.23,421.94c-5.5-24.17-23.09-101.05-28-106.11a27.8,27.8,0,0,1-6.94-14.36c-1-5.36-10.48-13-19.67-20.35a176.69,176.69,0,0,1-14.38-12.38c9,7.51,31.19,23,35.22,23.13,4.18.12,4.53,16.91,11.3,21.31C408.24,317.37,434.44,391.29,424.23,421.94Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.65,350.7c-12.26-3.33-23.26-28.32-23.88-34.42-.73-7.16-.6-12.64-9.11-22.22s-3.42-14.77-3.42-14.77c.68,3.21,6.44,8.24,6.44,8.24-2.32-7.21.33-33.4,1.42-38.29,1-4.3,1.38-30.83-4-39.61-6.29-3.93-5.7,2.73-10.63,2.39-2.67-.19-7.11-3.2-11.24-3.28-3.82-.05-3.85,5.15-14.61.15-5.41-2.52-8,5.19-14.23,2C392,206,385.69,188.26,379.54,183c-2.88-2.49-9.42-13.51-10.69-20.29-1-5.25-7.93-.37-11.22-6-2.7-4.65-1.23-11.35,6.39-9.42,2.18,4.89,9.49,21.26,12.16,25.76,1.49,2.52,4.94,8.26,8.45,14,.93-.05,6.07-.23,9.12,1.15a24.5,24.5,0,0,1,3.82,2.6c.89-.25,6.2-1.78,8.35-1.62s9.14,4.5,13.26,7.84a29.94,29.94,0,0,1,9.56-.17c3.39.56,10,4.23,15.3,7.16,2.36,1.32,4.4,2.45,5.61,3l1,.46c3.22,1.4,5,2.18,6.75,7.11,1.83,5.13,2.25,23.43,2.45,32.23l0,1.19c.08,3.36-.72,9.27-1.56,15.54-1.17,8.69-2.38,17.68-1.52,21.37a55.3,55.3,0,0,0,5.39,13.26l.83,1.6a39,39,0,0,1,3.08,9.23C467.83,315.92,470.37,326.36,484.65,350.7Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.94,207.12a15.23,15.23,0,0,1-7.37-5.49c-2.94-4.18-14.42-23.18-17.6-28.54s-12.79-27.2-12.79-27.2-6.23-2.28-8.84,3.53.35,19.17,3.93,24.39,20.19,45.13,21.56,46.44-1,11.76,1.7,14.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,231.26s-6.66,5.47-7.54,9.57l-4.65-5.8-.67-16.66s6-5.65,6.45-10.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,196.24s-11.07,9.87-16.25,11.54-2.53,39.88-3.1,50.91,37.92,31.37,40,42.74a27.47,27.47,0,0,0,6.89,14.23c5.91,6.09,29.7,113.41,29.7,113.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.5,187.21s5.88-.36,9.15,1.11S410,201.71,413.18,204s8,3.26,8.89,5.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.52,191s6.1-1.82,8.38-1.65,10.81,5.53,14.6,9a33,33,0,0,0,9.94,6.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,197.19a29.44,29.44,0,0,1,9.58-.19c4.88.8,17,8.39,20.85,10.13s5.74,2.1,7.65,7.44,2.28,25.41,2.47,33.34-4.59,30.52-3.07,37,4.46,11.45,6.23,14.92c5.21,10.22.39,15.74,23.81,54.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.58,211.94c4.38,4.93,2.46,13.13,1.47,15.5s.87,12.54,1.18,17.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.94,212.32c8.85,1.27,10.95,7.65,11,11.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.75,208c2.66.13,8.95,5.1,9.45,12.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.42,218.37s-.86-3.93-2.13-4.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.09,235a49.7,49.7,0,0,0,1.63,6.78c.89,2.4-.7,5.79-.7,5.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.74,240.83c-.27,3.8,3.39,8.35,4.33,7.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.29,228.18c5.29,2.65.19,30.46-8.4,37.82l-8.09,31.67,8.09,34.64L176,319.7s2-12.34,9.33-16.56,7.35,2.46,7.35,2.46-7.84,19.48-7.35,26.71-13.09,20.62-19.49,30.28-22.34,6.23-38.37,16.64-63,60-63,60L94.57,316.25Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,308.91a46.63,46.63,0,0,0-4,5.84c-.66,1.08-1.28,2.21-1.89,3.37-.28.51-.55,1-.81,1.55l-.1.2c-.3.59-.59,1.18-.89,1.78a2.56,2.56,0,0,1-.11.24c-.26.52-.5,1-.74,1.56s-.56,1.21-.82,1.81l0,0-.71,1.61c-.69,1.56-1.34,3.12-2,4.62s-1.15,2.84-1.68,4.16c-.06.13-.11.26-.16.39-.14.33-.27.66-.39,1-.63,1.59-1.21,3.05-1.74,4.32a1.94,1.94,0,0,1-.13.3c0,.08-.08.17-.13.25a14.2,14.2,0,0,1-4.35,4.36c-.35.25-.71.5-1.09.74-1,.69-2.19,1.37-3.41,2.06l-.93.5c-.75.41-1.51.81-2.3,1.2h0c-9,4.58-20.1,8.7-22.93,11.76-3.75,4.08-4.4,7.41-9,12.21h0a42.19,42.19,0,0,1-4.22,3.85c-5.81,4.71-19.31,29.83-27.64,46-4.15,8.05-7,13.89-7,13.89l-57.47-27s30.17-41.88,31.69-49,5.89-14.37,5.89-14.37-.75-16.06.34-27.34,3.8-30.25,5.08-37.83,8.71-19.44,12.27-28.47,5.61-17.19,8.76-22.74,6.21-15.38,8.06-16.42,3.81.6,5.82,3.47-2.84,19.55-2.84,19.55c3.52-5.8,5.73-17.78,7-20.89s3.72-17.55,3.72-17.55a14.4,14.4,0,0,1,4.21-1.85,6.69,6.69,0,0,1,4,.12c3.62,1.42,5.54,9.36,4.57,18.55s-6.14,28.92-6.14,28.92v0l15-22.78c2.9-4.42,7.9-21.79,8.79-22.91.65-.82,4.71-2.84,7.88-.87a7.25,7.25,0,0,1,2.91,4c2.63,7.67-5,24.91-6,28.29-.85,2.76-7.47,14.14-9.85,18.21l0,0-.76,1.31c.68-1,5.45-7.69,9-8.76,3.84-1.15,11.45-6.08,16.33-9.05s5.1-13.31,11.86-5c2.86,3.52,1.2,9.78-1.31,15.47s-14.52,15.92-14.52,15.92c-.46,1.29-1.59,4.28-3,7.92-.05.15-.11.29-.17.44-.24.66-.5,1.34-.77,2-.35.92-.72,1.87-1.09,2.82-.2.5-.39,1-.58,1.51s-.46,1.17-.69,1.75c-.11.3-.23.59-.34.88,0,.08-.06.17-.1.24-.19.5-.39,1-.58,1.48l-.33.84c-.4,1-.8,2-1.17,2.95a2.52,2.52,0,0,0-.12.29c-.1.23-.2.48-.29.71-.2.49-.39,1-.58,1.41s-.36.87-.52,1.28c-.76,1.8-1.35,3.12-1.65,3.63-1.54,2.6,3.48,29.91,7.48,26.5s14.46-20.32,14.46-20.32c1.47-9.77,7-17.52,14.42-20.74h0a19.33,19.33,0,0,1,1.92-.72c8.43-2.65,9.33,3.84,9.33,3.84C173.77,302.35,180.4,300.41,173.35,308.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,245.66l-14.3,21.85c1.21-8,8.31-25.1,8.31-25.1,1-6.55,9.63-37.11,6.74-41.92a11.75,11.75,0,0,0-3.21-2.42,6.69,6.69,0,0,1,4,.12c3.62,1.42,5.54,9.36,4.57,18.55S109.17,245.66,109.17,245.66Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.57,218.81h0l0,0c.07.09.25.33.51.71a12.14,12.14,0,0,0-.36-1.29Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,267.25s10.3-17.53,14.61-32.75c1.6-5.63,2.37-10.95,1.51-14.93h0a12.14,12.14,0,0,0-.36-1.29l-.18.54A14,14,0,0,0,92.12,216c.8,2.6,1.24,7.38-2.6,13.88C83.51,240.06,82.35,254.22,79,267.25Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,320.69c5.67-4.59,10.27-17.63,16.26-24.26,0,0-.19-11.84,12-21.24h0c-7.45,3.22-12.95,11-14.42,20.74,0,0-10.47,16.91-14.46,20.32s-9-23.9-7.48-26.5c.3-.51.89-1.83,1.65-3.64.17-.4.34-.83.53-1.27s.37-.93.57-1.41c.1-.23.19-.48.29-.71a2.52,2.52,0,0,1,.12-.29c.37-.94.76-1.93,1.17-2.95.11-.28.22-.56.34-.84.18-.49.38-1,.58-1.48,0-.08,0-.16.09-.25.11-.28.23-.57.34-.87.23-.58.45-1.16.69-1.75l.58-1.51c.37-.95.74-1.9,1.09-2.82.26-.69.52-1.37.78-2,.05-.15.11-.3.16-.44-.54,1.05-10.53,20.36-14.32,24.46s-.35,33.08,7.45,30.66C138.6,322.62,140.38,324.1,144.6,320.69Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,320.8c-1.09,11.28-.34,27.34-.34,27.34s-4.38,7.24-5.89,14.37c-.41,1.92-2.9,6.36-6.3,11.82.87-1.17,10.18-13.7,11.44-18.62,1.32-5.17,3.18-6.18,7.79-11.7s8.79-3.61,8.79-3.61-2.68,16.21,4.14,7,10.93-21.08,12.55-65.65c0,0-3,4.83-6,20.75s-8.09,19.61-8.09,19.61A150.89,150.89,0,0,1,68,287.51s-3.75,18.53-4.9,27.13-1.42-10.72-2-22.78c-.56-11.31.41-15.28,3.76-22.3-2.41,4.93-4.51,9.68-5.15,13.41C58.38,290.55,55.67,309.52,54.58,320.8Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,374.74a42.19,42.19,0,0,1-4.22,3.85c-5.81,4.71-19.31,29.83-27.64,46,1.67-7.09,4.67-17.07,9.71-25.94C99.87,382.78,108.77,378.6,113,374.74Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,231.42c-.85,2.76-7.47,14.14-9.85,18.21l0,0c-3,3.48-11.21,20.54-13.22,23s-5.86,2.67-4.15-1.11c2.79-6.17,11.25-27.3,15.62-31.4s11.09-21.44,14.49-31.19c1.71-4.93,1.19-8,.24-9.93a7.25,7.25,0,0,1,2.91,4C146.37,210.8,138.78,228,137.73,231.42Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43,233.16c-4.86,3-12.44,7.87-16.29,9,.52-.1,7.37-1.37,9.84,2.83,2.56,4.39,2.48,14.55,2.48,14.55s12-10.23,14.52-15.92,4.17-11.95,1.31-15.48C157.53,219.85,157.32,230.2,152.43,233.16Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.13,438.51s26-52.87,34.66-59.92,8.55-11,13.23-16.06,31.92-13,35.28-21.18,9-23.92,16.06-32.43.41-6.57,10.75-30.61c0,0-.92-6.49-9.34-3.84S160,285.34,158.43,295.94c0,0-10.47,16.9-14.47,20.31s-9-23.9-7.47-26.5,10.41-25.9,12-30.17c0,0,12-10.24,14.51-15.92s4.18-12,1.32-15.48c-6.76-8.33-7,2-11.86,5s-12.48,7.9-16.33,9.05S127,251.1,127,251.1s9.68-16.3,10.73-19.68,8.63-20.62,6-28.29-9.89-4.3-10.78-3.18-5.89,18.48-8.8,22.9l-15,22.81s5.17-19.71,6.14-28.91-1-17.14-4.57-18.57-8.23,1.74-8.23,1.74-2.41,14.43-3.73,17.54-3.53,15.1-7,20.9c0,0,4.85-16.69,2.84-19.56s-4-4.5-5.81-3.46-4.93,10.86-8.07,16.42-5.21,13.71-8.76,22.74S61,275.38,59.67,283s-4,26.56-5.09,37.84-.34,27.34-.34,27.34-4.38,7.24-5.89,14.37-31.69,49-31.69,49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,245.66c-2.9,3.64-12.07,19.87-14.3,21.85a8.52,8.52,0,0,1-4.18,2.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,238.36S91.11,242,86,252.89s-7.38,15.44-9.16,17.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,251.1c-4.28,6.28-8.68,17-10.94,19.93s-3.65,3.32-3.65,3.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,266.69a10.88,10.88,0,0,0-4.4,3.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,316.25s-3.84,8.84-9.4,6.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,289.75s-4.53,10.53-3.36,15.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39,277.08s-4.53,1.29-3.87,9-2.61,37-2.61,37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.48,279.74c-3.36,5.84-3.55,6-3.06,14.42s-.49,28.54-.49,28.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.24,348.14s3.95-4.42,3-9.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,378.59s-8.9,7.22-14.48,16.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.56f27e4ffea0b9c428d832a9bae18896.svg";
export { ForwardRef as ReactComponent };